import { render } from "./ParameterEdit.vue?vue&type=template&id=ff1d39f8"
import script from "./ParameterEdit.vue?vue&type=script&lang=js"
export * from "./ParameterEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__